// Single source of truth for the display-side tier table so the hero card and the tier reward
// cards cannot drift. Business values are fixed by the loyalty SoT (§11.2): Bonusguthaben rates
// 0 % / 5 % / 10 % at the 0 / 201 / 501 qualifying-point thresholds.
export const TIERS = [
    { name: 'Bronze', ratePercent: 0, minPoints: 0 },
    { name: 'Silber', ratePercent: 5, minPoints: 201 },
    { name: 'Gold', ratePercent: 10, minPoints: 501 },
];

// The MUI theme has no bronze/silver tokens, so the three tier accents are the one place where
// local colour constants are justified. Gold reuses the theme's secondary yellow.
export const TIER_STYLES = {
    Bronze: { bgcolor: '#a25b32', color: '#ffffff' },
    Silber: { bgcolor: '#d9dde2', color: 'text.primary' },
    Gold: { bgcolor: 'secondary.main', color: 'text.primary' },
};

// Returns null — not 0 — for a tier the frontend does not know (e.g. a tier added server-side
// later). Callers must hide the rate line in that case: telling the customer "0 %" when we simply
// do not know the rate is a wrong promise, and staying silent is the safer failure mode.
export const getTierRatePercent = (tierName) => {
    const tier = TIERS.find((candidate) => candidate.name === tierName);
    return tier ? tier.ratePercent : null;
};

// Tier names double as translation keys. An unknown name would otherwise render the raw key
// ("loyalty.tier.Platin"), so fall back to the name the API sent.
export const tierLabel = (t, tierName) => (tierName ? t(`loyalty.tier.${tierName}`, { defaultValue: tierName }) : '');

// Fallback is deliberately neutral grey, not gold — an unknown server-side tier must not falsely
// render as Gold (same "safer failure mode" reasoning as `getTierRatePercent`).
export const getTierStyle = (tierName) => TIER_STYLES[tierName] ?? { bgcolor: 'grey.300', color: 'text.primary' };
